import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { doLogout } from "../../../../store/reducer/_sessionReducer";

import { Logo } from "../../../components/global";

import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router";
import {
  LexIpAuthTokenPayload,
  LexSsoAuthTokenPayload,
  LexTokenPayload,
} from "../../../../models";
import { getLoggedUser } from "../../../../store/selectors";
import { getStoredToken } from "../../../../utils";
import { ssoUserManager } from "../../../../utils/sso";
import "../index.scss";

const isSsoToken = (
  token: LexTokenPayload | LexIpAuthTokenPayload | LexSsoAuthTokenPayload,
): token is LexSsoAuthTokenPayload => {
  return "type" in token && token.type === "sso_user";
};

const SSOLogout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const loggedUser = useSelector(getLoggedUser);
  const token = getStoredToken();

  useEffect(() => {
    const logout = async () => {
      try {
        if (!loggedUser) {
          navigate("/login");
          return;
        }

        const idToken = sessionStorage.getItem("sso_id_token");

        dispatch(doLogout());

        if (token) {
          const decoded = jwtDecode<
            LexTokenPayload | LexIpAuthTokenPayload | LexSsoAuthTokenPayload
          >(token);

          if (isSsoToken(decoded) && decoded.provider !== "AASP") {
            window.location.href = decoded.redirectUrl || "/login";
            return;
          }
        }

        sessionStorage.removeItem("sso_id_token");

        await ssoUserManager.removeUser();

        await ssoUserManager.signoutRedirect({
          id_token_hint: idToken,
        });
      } catch (err) {
        console.error("Erro logout SSO", err);

        sessionStorage.clear();
        localStorage.clear();

        window.location.href = "/login";
      }
    };

    logout();
  }, [dispatch, navigate, loggedUser, token]);

  return (
    <div className="auth-section">
      <Logo variant="lex" />

      <h2>Encerrando sessão...</h2>
    </div>
  );
};

export default SSOLogout;
